
define('text!widgets/casumo/view.html',[],function () { return '<div class="casumo-progress-container container-casumo"\n     data-bind="image: casumo().images.sumo, css: {container-spaceship: travelling}">\n</div>';});

